import React from 'react';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

/**
 * Component that prompts users to sign up or log in
 * Used as a replacement for BuyButton when user is not authenticated
 */
export const SignUpPrompt = ({ message = "Create an account to access this feature" }) => {
  const navigate = useNavigate();

  const handleSignUp = () => {
    // Navigate to the members page, which mounts the Authenticator.
    // (/account is not a real route - it falls through to the blog catch-all.)
    navigate('/members');
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <p style={{ marginBottom: '20px', fontSize: '16px' }}>{message}</p>
      <Button
        variant="primary"
        size="lg"
        onClick={handleSignUp}
        style={{
          padding: '12px 32px',
          fontSize: '18px',
          fontWeight: 'bold'
        }}
      >
        Sign Up / Log In
      </Button>
    </div>
  );
};
